/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import ProductCard from "./ProductCard";
import "swiper/css";
import "swiper/css/navigation";

export default function ProductRail({
  id,
  title,
  subtitle,
  products = [],
  theme,
  onAddToCart,
  onOpenProduct,
  onViewAll,
}) {
  if (!products.length) return null;

  return (
    <section id={id} className="t3-rail" dir="rtl">
      <div className="t3-container">
        <div className="t3-section-head">
          <div>
            <h2>{title}</h2>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          {onViewAll && (
            <button type="button" className="t3-link-all" onClick={onViewAll} style={{ color: theme.primary }}>
              عرض الكل
            </button>
          )}
        </div>

        <Swiper
          modules={[Autoplay, Navigation]}
          dir="rtl"
          spaceBetween={12}
          slidesPerView={2}
          navigation
          autoplay={{ delay: 4500, disableOnInteraction: false, pauseOnMouseEnter: true }}
          breakpoints={{
            0: { slidesPerView: 2, spaceBetween: 10 },
            640: { slidesPerView: 3, spaceBetween: 14 },
            1024: { slidesPerView: 4, spaceBetween: 16 },
            1280: { slidesPerView: 5, spaceBetween: 18 },
          }}
          className="t3-product-swiper"
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              <ProductCard
                compact
                product={product}
                theme={theme}
                onAddToCart={onAddToCart}
                onOpenProduct={onOpenProduct}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
